import TrackingWallet from '@aon-coverwallet/tracking-wallet';
import {getAppConfig} from '../utils/helpers/configHelper';

const trackingWalletConfig = {
    commonProps: {
        app: 'IdentityProvider',
        applicationMode: window.applicationModeName,
    }
};

if (window.amplitudeKey) {
    trackingWalletConfig.experiment = {
        amplitudeDeploymentKey: window.amplitudeKey
    };
}

const tracker = new TrackingWallet(trackingWalletConfig);

window.trackingWallet = tracker;

export function initTrackingWallet() {
    const isImpersonation = !!(window.App && window.App.isImpersonation);
    const {name, config} = getAppConfig();
    const {
        currentUserEmail,
        userRole,
        applicationMode,
        businessProfileId
    } = config;

    const isV2Appmode = window.isV2Appmode || false;

    let userId = null;
    if (!isImpersonation) {
        if (isV2Appmode && businessProfileId) {
            userId = businessProfileId;
        } else if (!isV2Appmode && currentUserEmail) {
            userId = currentUserEmail;
        }
    }

    if (window && window.analytics && window.trackingWallet && userId) {
        const identifyProps = {
            applicationMode,
            userRole,
            App: name,
        };

        if (isV2Appmode) {
            identifyProps.v2_appmode = true;
        }

        window.trackingWallet.identify(userId, identifyProps);
    }
}
